module.exports = __webpack_public_path__ + "img/QiBao.bfe87f64.png";